import { useState, useEffect } from 'react';

export const useLocalStorageSync = () => {
  const [particlesEnabled, setParticlesEnabled] = useState(() => {
    // Try to get saved particles preference from localStorage, default to false
    const saved = localStorage.getItem('particles-enabled');
    return saved !== null ? JSON.parse(saved) : false;
  });

  const [chatSidebarViewMode, setChatSidebarViewMode] = useState(() => {
    // Try to get saved view mode preference from localStorage, default to 'concise'
    const saved = localStorage.getItem('chat-sidebar-view-mode');
    return saved !== null ? saved : 'concise';
  });

  // Save particles preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('particles-enabled', JSON.stringify(particlesEnabled));
  }, [particlesEnabled]);

  // Save sidebar open state to localStorage when it changes
  const syncSidebarState = (isSidebarOpen) => {
    localStorage.setItem('sidebar-open', JSON.stringify(isSidebarOpen));
  };

  // Save chatSidebarViewMode preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('chat-sidebar-view-mode', chatSidebarViewMode);
  }, [chatSidebarViewMode]);

  return {
    particlesEnabled,
    setParticlesEnabled,
    chatSidebarViewMode,
    setChatSidebarViewMode,
    syncSidebarState
  };
};